<template>
<div class="chapter">
<div class="inner_page">
<p class="h2d"><a id="page_25"></a><a id="frontmatter1"></a><span>APHORISMS OF THE PROFESSOR.</span></p>
<p class="h2d1"><span><span class="smallcaps">TO SERVE AS PROLEGOMENA TO HIS WORK AND ETERNAL BASIS TO THE SCIENCE.</span></span></p>
<p class="indent">I. T<span class="smallcaps">HE</span> universe would be nothing were it not for life, and all that lives must be fed.</p>
<p class="indent">II. Animals fill themselves; man eats. The man of mind alone knows how to eat.</p>
<p class="indent">III. The destiny of nations depends on the manner in which they are fed.</p>
<p class="indent">IV. Tell me what kind of food you eat, and I will tell you what kind of man you are.</p>
<p class="indent">V. The Creator, when he obliges man to eat, invites him to do so by appetite, and rewards him by pleasure.</p>
<p class="indent">VI. <i>Gourmandise</i> is an act of our judgment, in obedience to which, we grant a preference to things which are agreeable, over those which have not that quality.</p>
<p class="indent">VII. The pleasure of the table belongs to all ages, to all conditions, to all countries, and to all æras; it mingles with all other pleasures, and remains at last to console us for their departure.</p>
<p class="indent"><a id="page_26"></a>VIII. The table is the only place where one does not suffer from <i>ennui,</i> during the first hour.</p>
<p class="indent">IX. The discovery of a new dish confers more happiness on humanity, than the discovery of a new star.</p>
<p class="indent">X. Those persons who suffer from indigestion, or who become drunk, are utterly ignorant of the true principles of eating and drinking.</p>
<p class="indent">XI. The order of food is from the most substantial to the lightest.</p>
<p class="indent">XII. The order of drinking is from the mildest to the most foamy and perfumed.</p>
<p class="indent">XIII. To say that we should not change our drinks is a heresy; the tongue becomes saturated, and after the third glass yields but an obtuse sensation.</p>
<p class="indent">XIV. A dessert without cheese is like a beautiful woman who has lost an eye.</p>
<p class="indent">XV. A cook may be taught, but a man who can roast, is born with the faculty.</p>
<p class="indent">XVI. The most indispensable quality of a good cook is promptness. It should also be that of the guests.</p>
<p class="indent">XVII. To wait too long for a dilatory guest, shows disrespect to those who are punctual.</p>
<p class="indent">XVIII. He who receives friends and pays no attention to the repast prepared for them, is not fit to have friends.</p>
<p class="indent"><a id="page_27"></a>XIX. The mistress of the house should always be certain that the coffee be excellent; the master that his <i>liquors</i> be of the first quality.</p>
<p class="indent">XX. To invite a person to your house is to take charge of his happiness as long as he be beneath your roof.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter1.vue?ebbeceb4